import { memo, useCallback, useState } from 'react';
import { TeContainer } from '@topcon/tuicl-react';

import TerminateCancelServiceAgreementModal from './Customer/TerminateCancelServiceAgreementModal';
import ServiceAgreementRow from './Common/ServiceAgreementRow';
import { ServiceAgreement } from './Common/ServiceAgreementTypes';
import {
  ReviewSource,
  navigateToCustomerSupportAuthURL,
  navigateToReviewPage,
} from './serviceAgreementReviewNavigation';

type ServiceAgreementsTableProps = {
  agreements: ServiceAgreement[];
  onClose?: (shouldUpdate: boolean) => void;
};

function ServiceAgreementsTableBase({ agreements, onClose }: ServiceAgreementsTableProps) {
  const [selectedServiceAgreement, setSelectedServiceAgreement] = useState<ServiceAgreement>();
  const [openTerminateAgreementModal, setOpenTerminateAgreementModal] = useState<boolean>(false);

  const handleRevokeAgreement = useCallback((sa: ServiceAgreement) => {
    setSelectedServiceAgreement(sa);
    setOpenTerminateAgreementModal(true);
  }, []);

  const handleReviewAgreement = useCallback((sa: ServiceAgreement) => {
    navigateToReviewPage(sa.id, ReviewSource.Dealers);
  }, []);

  const handleSupportCustomer = useCallback((sa: ServiceAgreement) => {
    const bpId = sa.customerBusinessPartnerId;
    navigateToCustomerSupportAuthURL(sa.id, bpId);
  }, []);

  const handleCloseTerminateAgreementDialog = useCallback(
    (shouldUpdate: boolean) => {
      setOpenTerminateAgreementModal(false);
      onClose?.(shouldUpdate);
    },
    [onClose]
  );

  return (
    <>
      <TeContainer fill column padding="m" gap="xs">
        {agreements.map((agreement) => (
          <ServiceAgreementRow
            key={agreement.id}
            sa={agreement}
            onReview={() => handleReviewAgreement(agreement)}
            onCancelRequest={(row) => handleRevokeAgreement(row)}
            onDeleteRequest={(row) => handleRevokeAgreement(row)}
            onSupportCustomer={(row) => handleSupportCustomer(row)}
          />
        ))}
      </TeContainer>

      {selectedServiceAgreement && (
        <TerminateCancelServiceAgreementModal
          serviceAgreement={selectedServiceAgreement}
          kind="agreement"
          open={openTerminateAgreementModal}
          onClose={handleCloseTerminateAgreementDialog}
        />
      )}
    </>
  );
}

const ServiceAgreementsTable = memo(ServiceAgreementsTableBase);
export default ServiceAgreementsTable;
